export default {
    fund: [{
            "title": "关于基金产品风险与基金投资人风险承受能力匹配，以下表述正确的是（　　）",
            "questions": "I. 在销售过程中基金产品风险和基金投资人风险承受能力需进行匹配<br>II. 基金产品风险超越基金投资人风险承受能力的情况定义为风险不匹配<br>III. 不能推荐投资人认购或申购风险超越投资人风险承受能力的基金产品<br>IV. C5型普通投资者可以购买所有风险等级的基金产品",
            "question": "A. I、III、IV\nB. II、III、IV\nC. I、II、III、IV\nD. I、II、IV",
            "answer": "C",
            "explain": "本题考查投资者与基金产品的风险匹配。基金销售机构应当制定基金产品和基金投资人匹配的方法，在销售过程中由销售业务信息管理平台完成基金产品风险和基金投资人风险承受能力的匹配检验，I、II、III、IV均表达正确。"
        },
        {
            "title": "基金管理人公司监察稽核控制，错误的是（　　）",
            "question": "A. 公司督察长应当定期或不定期向全体董事报送工作报告\nB. 公司应当设立监察稽核部门，对董事会负责\nC. 各家长根据履行职责的需要，有权调阅公司相关文件、档案\nD. 公司董事会和经理层应当重视和支持监察稽核工作",
            "answer": "B",
            "explain": "本题考查监察稽核控制。A选项正确，基金管理人应当设立督察长，对董事会负责，并定期或不定期向全体董事报送工作报告。B选项错误，公司应当设立监察稽核部门，对公司经理层负责，开展监察稽核工作，公司应确保监察稽核部门的独立性和权威性。C选项正确，根据公司监察稽核工作的需要和董事会授权，督察长可以列席公司相关会议，调阅公司相关档案。D选项正确，基金管理人董事会和管理层应当重视和支持监察稽核工作，对违反法律法规和公司内部控制制度的，应当追究有关部门和人员的责任。"
        },
        {
            "title": "关于基金份额的转换的规则，以下说法正确的是（　　）",
            "question": "A. 按照转换申请日下一日的单位净值计算转换基金的份额数量\nB. 基金份额的转换不需要额外支付转换费用\nC. 基金份额的转换不需缴纳转出基金的赎回费,需要支付转入基金的申购费\nD. 一般采用未知价法",
            "answer": "D",
            "explain": "本题考查开放式基金份额的转换。开放式基金份额的转换是指投资者不需要先赎回已持有的基金份额，就可以将其持有的基金份额转换为同一基金管理人管理的另一基金份额的一种业务模式。基金份额的转换一般采取未知价法，按照转换申请日的基金份额净值为基础计算转换基金份额数量。基金份额的转换常常还会收取一定的转换费用。尽管如此，由于基金份额的转换不需要先赎回已持有的基金再购买另一基金，因此，综合费用仍较低。"
        },
        {
            "title": "在基金临时信息披露时，信息披露义务人应当在重大事件发生之日起（　　）日内编辑并披露临时报告书",
            "question": "A. 5\nB. 2\nC. 3\nD. 1",
            "answer": "B",
            "explain": "如果预期某种信息可能对基金份额持有人权益或者基金份额的价格产生重大影响，则该信息为重大信息，相关事件为重大事件，信息披露义务人应当在重大事件发生之日起2日内编制并披露临时报告书。"
        },
        {
            "title": "关于私募基金交易记录及相关文件的保存，以下描述正确的是（　　）",
            "questions": "I. 私募基金管理人和基金销售机构都应该保存交易记录<br>II. 投资决策、交易和投资者适当性管理等文件资料也需要保存<br>III. 保存期限自基金清算终止之日起不少于10年<br>IV. 基金托管人可以不保存交易记录",
            "question": "A. II、III\nB. I、II、III\nC. I、III\nD. I、II、III、IV",
            "answer": "B",
            "explain": "本题考查私募基金相关文件的保存。私募基金，是指以非公开方式向投资者募集资金设立的投资基金。"
        },
        {
            "title": "客户利益优先是客户至上准则的重要组成部分，以下关于基金从业人员遵守客户利益优先职业道德准则的说法中错误的是（　　）",
            "question": "A. 不得接受亲属认购基金的申请\nB. 不得在执业活动中为自己或他人谋取不正当利益\nC. 不得挪用客户的交易资金和基金份额\nD. 遇到自身利益与客户利益冲突时，应向所在机构报告",
            "answer": "A",
            "explain": "本题考查客户至上的基本要求。A选项说法错误，客户至上的基本要求中未涉及关于亲属认购基金申请的规定。B选项说法正确，客户至上要求不得在执业活动中为自己或他人谋取不正当利益。C选项说法正确，客户至上要求不得侵占或挪用基金投资人的交易资金和基金份额。D选项说法正确，客户利益优先要求在执业过程中遇到自身利益或相关方利益与投资人利益发生冲突时，应以投资人利益优先，并应及时向所在机构报告。"
        }, {
            "title": "根据现行法律法规，符合一定要求，可以向证监会申请成为基金销售机构的主体包括（　　）项。",
            "questions": "I. 保险经理公司<br>II. 保险代理公司<br>III. 信托公司<br>IV. 期货公司",
            "question": "A. I、II、III、IV\nB. II、III、IV\nC. I、III、IV\nD. I、II、IV",
            "answer": "D",
            "explain": "本题考查基金销售机构的类型。基金销售机构是指依法办理基金份额的认购、申购和赎回的基金管理人以及取得基金代销业务资格的其他机构。基金销售机构可分为直销机构和代销机构两种类型。"
        },
        {
            "title": "证券投资基金有助于防止市场的过度投机，具体体现在证券投资基金（　　）",
            "question": "A. 有助于改善我国目前以个人投资者为主的投资者结构\nB. 有助于发挥机构投资者对上市公司的监督和制约作用\nC. 有助于促进信息的有效利用和传播，实现资源合理配置\nD. 有助于推动市场价值体系的形成，倡导理性的投资文化",
            "answer": "D",
            "explain": "本题考查基金业在金融体系中的地位与作用。D选项符合题意，证券投资基金发挥专业理财优势，推动市场价值判断体系的形成，倡导理性的投资文化，有助于防止市场的过度投机。"
        },
        {
            "title": "关于基金销售机构对基金销售费用的内部规范管理，以下表述错误的是（　　）",
            "questions": "I. 基金销售机构可根据投资人的投资规模自行决定费率水平<br>II. 基金销售机构可自行决定销售的基金产品<br>III. 基金销售机构应当加强后台管理系统对费率的合规控制<br>IV. 基金销售机构的分支机构可以自主决定基金销售费用",
            "question": "A. I、II、IV\nB. II、IV\nC. I、IV\nD. I、II、III、IV",
            "answer": "C",
            "explain": "本题考查基金销售费用具体规范。I项错误，基金销售机构应当按照基金合同和招募说明书的约定向投资人收取销售费用：未经招募说明书载明并公告，不得对不同投资人适用不同费率。"
        },
        {
            "title": "关于基金招募说明书中的风险提示，以下表述错误的是（　　）",
            "question": "A. 可以在招募说明书最后的页脚不显著位置，做出“不保证基金一定盈利”的表述\nB. 应该在招募说明书的正文，就基金投资于融资融券的风险因素进行分析\nC. 可以在招募说明书封面的显著位置，做出“基金过往业绩不预示未来表现”的表述\nD. 应该在招募说明书的正文，列明与特定基金品种相关的特定风险",
            "answer": "A",
            "explain": "本题考查基金风险提示。A选项表述错误，C选项表述正确。在招募说明书封面的显著位置，管理人一般会做出“基金过往业绩不预示未来表现；不保证基金一定盈利，也不保证最低收益”等风险提示。B、D选项表述正确。在招募说明书正文，管理人还会就基金产品的各项风险因素进行分析，并列明与特定基金品种、特定投资方法或特定投资对象相关的特定风险。"
        },
        {
            "title": "以下各类别基金中，以基金份额可上市交易为固有特征的是（　　）",
            "question": "A. ETF\nB. 联接基金\nC. 基金中基金\nD. 商品基金",
            "answer": "A",
            "explain": "本题考查证券投资基金的分类标准。A选项符合题意，ETF的最大特点就是基金份额可上市交易，这也是它的固有特征。"
        },
        {
            "title": "关于股票与基金的特点，以下表述错误的是（　　）",
            "question": "A. 基金的投资收益和风险取决于基金种类和投资对象\nB. 通常情况下，股票是一种高风险、高收益的投资品种，价格波动性较大\nC. 股票是直接投资工具，筹集的资金主要投资于实业领域\nD. 基金反映的是一种所有权关系，是一种所有权凭证",
            "answer": "D",
            "explain": "本题考查基金与股票、债券的差异。A选项表述正确，基金的投资收益和风险取决于基金种类和投资对象，总体来说由于基金可以投资于众多金融工具或产品，能有效分散风险，是一种风险相对适中、收益相对稳健的投资品种。B选项表述正确，通常情况下，股票是一种高风险、高收益的投资品种，价格波动性较大。C选项表述正确，股票是直接投资工具，筹集的资金主要投资于实业领域。"
        }, {
            "title": "根据《证券投资基金销售管理办法》的规定，在缺乏足够证据支持的情况下，基金宣传推介材料不得使用的表述包括（　　）",
            "questions": "I. 首只<br>II. 唯一<br>III. 最好<br>IV. 最大",
            "question": "A. III、IV\nB. II、III\nC. I、II、III、IV\nD. II、III、IV",
            "answer": "C",
            "explain": "基金宣传推介材料所使用的语言表述应当准确清晰，应当特别注意：首只、唯一、最好、最大。"
        },
        {
            "title": "甲是基金管理公司基金经理，利用业余时间在某私募机构兼职提供投资咨询。该情形被发现后，甲声称绝没有泄露基金管理公司投资信息，关于甲的行为，以下表述错误的是（　　）",
            "question": "A. 甲的行为不符合廉洁奉公规范的要求，也违反了竞业禁止的一般规则\nB. 在甲没有泄露基金管理公司投资信息的前提下，甲可以为私募机构提供投资咨询服务\nC. 甲应该意识到该行为与所在基金管理公司存在利益冲突，应主动回避\nD. 甲的行为，违反了忠诚尽责的职业道德规范",
            "answer": "B",
            "explain": "基金管理公司与该私募机构属于同一行业，可能与本公司产生利益冲突，故甲不可以为私募机构提供投资咨询服务。"
        },
        {
            "title": "基金管理人风险管理的内部环境要素包括（　　）",
            "questions": "I. 员工的诚信、道德价值观和胜任能力<br>II. 管理层的理念和经营风格<br>III. 管理层分配权利和划分责任、组织和开发员工的方法<br>IV. 董事会给予的关注和指导",
            "question": "A. II、III、IV\nB. I、II、IV\nC. I、II、III\nD. I、II、III、IV",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "关于基金销售机构对普通投资者需要承担的特别责任和要求，以下表述正确的是（　　）",
            "questions": "I. 应对普通投资者进行细化分类管理<br>II. 不得主动推介超越投资者风险承受能力的产品<br>III. 应完善配套留痕安排<br>IV. 禁止普通投资者转化为专业投资者",
            "question": "A. I、II、III、IV\nB. I、II、III\nC. I、II、IV\nD. I、III、IV",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "关于基金管理人内部控制基本要素，以下说法错误的是（　　）",
            "question": "A. 控制环境包括经营理念、内控文化、公司治理结构、组织结构、员工道德素质等\nB. 控制活动可以通过授权控制来进行\nC. 内部监控是指督察长对公司内控制度的执行情况进行持续的监督\nD. 风险评估是指公司内外部风险进行识别、评估和分析，及时防范和化解风险",
            "answer": "C",
            "explain": "本题考查内部控制基本要素。A选项说法正确，控制环境构成公司内部控制的基础，包括经营理念和内控文化、公司治理结构、组织结构、员工道德素质等内容。B选项说法正确，基金管理人可以通过授权控制来控制业务活动的运作。授权控制应当贯穿于公司经营活动的始终。"
        },
        {
            "title": "中国证券投资基金业协会在基金管理人登记、基金备案、投资情况报告要求和会员管理等环节，对其中一类非公开募集基金采取了区别于其它非公开募集基金的差异化行业自律，并提供差异化会员服务，该类基金是（　　）",
            "question": "A. 私募证券投资基金\nB. 创业投资基金\nC. 基金子公司专项计划\nD. 券商集合计划",
            "answer": "B",
            "explain": ""
        }, {
            "title": "关于基金管理人内部控制机构设置，以下表述错误的是（　　）。",
            "question": "A. 基金管理人应建立专职的内部管理机构\nB. 基金管理人所有员工都应该重视内部控制\nC. 内部控制机制要兼顾企业的商业利润\nD. 基金管理人从组织上强化内部控制",
            "answer": "C",
            "explain": "在内部控制机构设置上，不能出现重眼前商业利润（C选项错误）、不注重专职内部控制机构建立的偏向（A选项正确）。建立健全基金管理人内部控制。"
        },
        {
            "title": "某银行网点宣传该行T+0产品“XX宝”，“XX宝”对接某只货币市场基金以下做法合规的是（　　）。",
            "question": "A. 向在该行办理存款的客户宣传“XX宝”和定期存款一样，且收益有时更好，是定期存款的替代品\nB. 根据历史业绩，向客户宣传“XX宝”收益率高于3.50%，大幅高于活期存款\nC. 向客户推介“XX宝”灵活便捷，并说明由于对接货币市场基金，可能由于垫资额度产生赎回资金不能实时到账\nD. 向客户宣传该行新的保本理财产品“XX宝”销售火爆，资金使用方便灵活",
            "answer": "C",
            "explain": "A选项不合规，货币市场基金是存在风险的，并不能确保本金安全，只是风险相对其他基金来说较低，A选项宣传“XX宝”是保本理财产品是不合规的。"
        },
        {
            "title": "A银行理财经理小王向投资者李大妈介绍B基金的表现情况，以下行为违反相关法律法规的是（　　）。",
            "question": "A. 小王根据自己的研究预测未来B基金的业绩表现情况\nB. 小王向李大妈提供B基金业绩的原始出处\nC. 小王客观地介绍了B基金的历史业绩情况\nD. 小王把A银行统一制作的B基金业绩情况发给李大妈",
            "answer": "A",
            "explain": "基金销售人员的禁止性规范有：（1）基金销售人员对基金产品的陈述、介绍和宣传，应当与基金合同、招募说明书等相符，不得进行虚假或误导性陈述，或者出现重大遗漏(D选项说法正确)；"
        },
        {
            "title": "关于证券投资基金业在金融体系的地位和作用，以下概述中错误的是（　　）。",
            "question": "A. 有利于证券市场的稳定、健康发展\nB. 为专业机构投资者投资实体经济，拓宽了投资渠道\nC. 优化金融机构，促进经济增长\nD. 完善了金融体系和社会保障体系",
            "answer": "B",
            "explain": "B选项概述错误，证券投资基金业为中小投资者拓宽投资渠道(而不是为专业机构投资者)。"
        },
        {
            "title": "关于基金销售适用性的实施保障，以下表述正确的是（　　）。",
            "questions": "I. 基金销售机构应当通过内部控制保障基金销售适用性在基金销售各个业务环节的实施<br>II. 基金销售机构应当负责制定与基金销售适用性相关的制定和程序、建立销售基金产品池<br>III. 基金销售机构应当就基金销售适用性的理论和实践对基金销售人员实行专题培训<br>IV. 基金销售机构应当就基金产品风险收益特征与投资人的风险承受能力进行匹配性测试",
            "question": "A. I、II、III、IV\nB. I、II、III\nC. II、III、IV\nD. I、III、IV",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "证券期货市场诚信档案采集公民信息应符合法律法规规定，不得采集的公民信息包括（　　）。",
            "questions": "I. 宗教信仰<br>II. 性别<br>III. 血型<br>IV. 病史信息",
            "question": "A. II、III、IV\nB. I、II、III、IV\nC. I、III、IV\nD. I、II、IV",
            "answer": "C",
            "explain": ""
        }, {
            "title": "跨境ETF基金T日份额净值在指定银行和管理人网站披露的最晚时期是（　　）。",
            "question": "A. T+2日\nB. T+1日\nC. T日\nD. T+3日",
            "answer": "A",
            "explain": "跨境ETF在交易日的基金份额净值可以为次2个工作日在指定报刊和管理人网站披露外，也将通过证券交易所的行情发布系统于次2个工作日揭示。A选项符合题意。"
        },
        {
            "title": "某货币市场基金T日规模30亿元，T+1日净回10亿元，触发巨额赎回，基金公司采取的以下措施中不合规的是（　　）。",
            "question": "A. 暂停接受赎回申请\nB. 接受3亿元赎回申请，其余7亿元赎回申请延期至T+2日处理\nC. 接受5亿元赎回申请，其余5亿元赎回申请延期至T+2日处理\nD. 接受10亿元赎回申请",
            "answer": "A",
            "explain": "B、D选项做法合规，当基金管理人认为兑付投资者的赎回申请有困难，或认为兑付投资者的赎回申请进行的资产变现可能使基金份额净值发生较大波动时，基金管理人可以在当日接受赎回比例不低于上一日基金总份额10%的前提下，对其余赎回申请延期办理。30×10%=3亿元。当日接受的赎回申请应大于等于3亿元。"
        },
        {
            "title": "某金融机构在了解投资者的个人背景和社会环境后，指导投资者分析投资问题、获得必要信息并进行理性选择，该行为属于投资者教育中的（　　）。",
            "question": "A. 资产平衡教育\nB. 权益保护教育\nC. 投资决策教育\nD. 防范诈骗教育",
            "answer": "C",
            "explain": "投资者教育的内容包括：（1）投资决策教育：就是要在指导投资者分析投资问题、获得必要信息、进行理性选择的同时，致力于改善投资者决策条件中的某些变量。（C选项符合题意）"
        },
        {
            "title": "关于基金销售机构应具备相应的准入条件，以下说法错误的是（　　）。",
            "question": "A. 必须具备选择优秀基金管理人的方法体系\nB. 有与基金销售业务相适应的营业场所、安全防范设施和其他设施\nC. 有安全、高效的办理基金发售、申购和赎回等业务的技术设施\nD. 制定了完善的业务流程、销售人员执业操守、应急处理措施等基金销售业务管理制度",
            "answer": "A",
            "explain": "申请基金销售资格应具备的条件包含：（1）具有健全的治理结构、完善的内部控制和风险管理制度，并得到有效执行；（2）财务状况良好，运作规范稳定；"
        },
        {
            "title": "2017年3月1日星期三，某私募基金公司发生有关所管理私募基金投资运作方面的重大事项，按规定需要向中国证券投资基金业协会报告，由于2017年3月国家没有法定假日，该报告的截止日应该为（　　）。",
            "question": "A. 2017/3/13\nB. 2017/3/16\nC. 2017/3/15\nD. 2017/3/6",
            "answer": "C",
            "explain": "私募基金管理人应当根据基金业协会的规定，及时填报并定期更新管理人及其从业人员的有关信息、所管理私募基金的投资运作情况和杠杆运用情况，保证所填报内容真实、准确、完整。发生重大事项的，应当在10个工作日内向基金业协会报告。3月1号星期三，10个工作日内，为2号，3号，6"
        },
        {
            "title": "关于私募基金销售的回访工作，以下表述错误的是（　　）。",
            "questions": "I. 募集机构应当在投资冷静期内，及时安排人员对投资者进行回访<br>II. 募集机构应指令专业从事基金销售业务的人员进行回访<br>III. 募集机构以录音电话、电邮、信函等方式进行回访<br>IV. 回访确认成功前，投资者缴纳的认购基金款项应及时划转到托管资金账户以保证安全",
            "question": "A. I、III、IV\nB. I、II、III\nC. II、III、IV\nD. I、II、IV",
            "answer": "D",
            "explain": "I项表述错误，募集机构应当在投资冷静期满后(而非冷静期内)，及时安排人员对投资者进行回访。"
        }, {
            "title": "契约型基金与公司型基金的主要区别有以下哪几项（　　）。",
            "questions": "I. 法律主体资格不同<br>II. 投资者的地位不同<br>III. 基金组织方式不同<br>IV. 基金运作管理标准不同",
            "question": "A. I、IV\nB. I、II\nC. I、II、III\nD. I、II、III、IV",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "基金执业道德教育的途径不包括（　　）。",
            "question": "A. 树立基金职业道德典型\nB. 对'老鼠仓'案件的审判\nC. 岗前职业道德教育\nD. 社会各界持续监督",
            "answer": "B",
            "explain": "本题考查基金职业道德教育的途径。基金职业道德教育的途径包括：（1）岗前职业道德教育(C选项表述正确)；（2）岗位职业道德教育；"
        },
        {
            "title": "关于对私募基金从业人员的要求，以下表述错误的是（　　）。",
            "question": "A. 私募基金管理人的高级管理人员最近三年没有重大失信记录\nB. 私募基金管理人应当按照规定向中国证券投资基金业协会报送高级管理人员及其他基金从业人员本人、直系亲属、利害关系\nC. 私募基金从业人员应当定期参加中国证券投资基金业协会或其认可机构组织的执业培训\nD. 从事私募基金业务的专业人员应当具备基金从业资格",
            "answer": "B",
            "explain": "A选项表述正确，担任私募基金管理人的高级管理人员应当最近三年没有重大失信记录。B选项表述错误，基金管理人的董事、监事、高级管理人员和其他从业人员，其本人、配偶、利害关系人进行证券投资，应事先向基金管理人申报，只有在进行投资时才需向协会报送基本信息。"
        },
        {
            "title": "基金销售机构的以下做法，不符合基金销售人员管理和培训要求的是（　　）。",
            "question": "A. 通过网络方式将所属取得基金销售从业资格人员的姓名、从业资质证明等信息进行披露\nB. 对所属已获得基金销售资格的从业人员，由基金销售机构来组织与基金销售相关的职业培训\nC. 要求基金销售人员及时自行办理执业注册并反馈办理情况\nD. 对基金销售人员的销售行为、流动情况进行登记管理",
            "answer": "C",
            "explain": "本题考查基金销售机构人员的管理培训相关内容。C项不符合要求，基金销售机构对于通过基金业协会资质考核并获得基金销售资格的基金销售人员，统一办理执业注册，后续培训和执业年检。"
        },
        {
            "title": "关于基金营销的特殊性，以下说法正确的是（　　）。",
            "question": "A. 基金营销是一种产品的营销行为，目的是将基金产品销售给客户\nB. 为促进基金销售，基金销售机构为投资者提供合理的收益预测\nC. 应根据投资者的风险承受能力，销售不同风险等级的基金\nD. 基金营销人员应注意营销的技巧与策略而非相关金融知识",
            "answer": "C",
            "explain": "本题考查基金营销的特殊性。A选项说法错误，基金营销不同于一般产品营销，其目的不是单纯把基金产品销售给投资者，而是根据投资者需求为其选择适当的产品，并提供持续服务。"
        },
        {
            "title": "私募基金的投资范围可包括（　　）。",
            "questions": "I. 公司股权<br>II. 债券<br>III. 基金份额<br>IV. 期货",
            "question": "A. I、II、III、IV\nB. II、III、IV\nC. I、II、IV\nD. I、II、III",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "关于私募基金管理人办理基金备案手续需要报送的信息，以下表述错误的是（　　）。",
            "question": "A. 采取委托管理方式，应当报送委托管理协议\nB. 不需要提交招募说明书\nC. 主要投资方向及根据主要投资方向注明的基金类别\nD. 需要提交基金合同，公司章程或者合伙协议",
            "answer": "B",
            "explain": "本题考查私募基金的备案。私募基金募集完毕，基金管理人应当根据基金业协会的规定，办理基金备案手续，报送以下基本信息："
        }, {
            "title": "关于另类投资基金，以下表述正确的是（　　）。",
            "question": "A. 另类投资基金是一种直接投资工具\nB. 黄金基金属于另类投资基金\nC. 另类投资基金可投资于债券、股票\nD. 另类投资基金是私募基金",
            "answer": "B",
            "explain": "此题考查另类投资基金的特点。A选项错误，另类投资基金是一种间接投资工具。B选项正确，C选项错误，另类投资基金是指投资于传统的股票、债券之外的金融和实物资产的基金，如房地产、证券化资产、对冲基金、大宗商品、黄金、艺术品等。"
        },
        {
            "title": "基金宣传推介材料不得登载的内容是（　　）。",
            "question": "A. 本公司的品牌形象宣传材料\nB. 单位或个人的推荐性文字\nC. 基金产品的基本要素\nD. 投资者教育的相关信息",
            "answer": "B",
            "explain": "本题考查基金宣传推介材料的禁止性规定。基金宣传推介材料的禁止性行为：（1）虚假记载、误导性陈述或者重大遗漏；"
        },
        {
            "title": "关于基金销售费用，以下表述正确的是（　　）。",
            "question": "A. 基金中期报告中应披露管理费中支付给基金销售机构的客户维护费总额\nB. 基金销售机构可以和基金管理人协议约定，按照交易量提取一定的客户维护费\nC. 对于不同的投资人，基金销售机构可以在基金招募说明书载明和公告之外，采用不同的费率\nD. 基金销售机构提取的客户维护费从基金销售服务费中列支",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "基金管理公司独立董事人数不得少于（　　）人，且不得少于董事会人数的（　　）。",
            "question": "A. 2;1/3\nB. 3;1/3\nC. 3;1/2\nD. 2;1/2",
            "answer": "B",
            "explain": "根据相关法律法规，独立董事人数不得少于3人，且不得少于董事会人数的1/3。"
        },
        {
            "title": "关于基金的信息披露，以下表述错误的是（　　）。",
            "question": "A. 信息披露的完整性原则并不是要求事无巨细披露所有信息\nB. 基金信息披露有利于防止利益冲突与利益输送\nC. 信息披露的方式只能在中国证监会指定的报刊上进行披露\nD. 强制性信息披露是世界各国(地区)证券市场监管的普遍做法",
            "answer": "C",
            "explain": "C项说法错误，基金信息披露不仅能在中国证监会指定的报刊上进行披露，还可以在中国证监会指定的信息披露媒体上公告。"
        },
        {
            "title": "《证券投资基金管理公司治理准则(试行)》第十八条规定'公司应当将与股东签署的有关技术支持、服务、合作等协议报送中国证监会及相关派出机构'。这一规定体现了公司治理的（　　）原则。",
            "question": "A. 公平对待\nB. 经营运作公开、透明\nC. 业务与信息隔离\nD. 公司独立运作",
            "answer": "D",
            "explain": "A选项不符合题意，公平对待原则是指：公司董事会和经理层应当公平对待所有股东，不得接受任何股东及其实际控制人超越股东会、董事会的指示，不得偏向任何一方股东。公司开展业务应当公平对待管理的不同基金财产和客户资产，不得在不同基金财产之间、基金财产与委托资产之间进行利益输送。"
        }, {
            "title": "基金公司应建立完善的资产分离制度和岗位分离制度，以下说法错误的是（　　）。",
            "question": "A. 投资和交易岗位要分离设置\nB. 基金资产与公司资产独立运作\nC. 交易和清算岗位可以兼职\nD. 不同基金资产独立运作",
            "answer": "C",
            "explain": "本题考查内部控制的基本要素。A选项说法正确，资产分离制度要求投资和交易岗位要分离设置。B选项说法正确，资产分离制度要求基金资产与公司资产独立运作。"
        },
        {
            "title": "私募基金管理人向中国证券投资基金业协会办理基金备案手续时需要报送基本信息，下列说法错误的是（　　）。",
            "question": "A. 有限合伙型基金应当报送公司章程\nB. 应报送主要投资方向的信息\nC. 采用委托管理方式的，应当报送委托管理协议\nD. 契约型基金应当报送基金合同",
            "answer": "A",
            "explain": "《私募投资基金监督管理暂行办法》规定，各类私募基金募集完毕，私募基金管理人应当根据基金业协会的规定，办理基金备案手续，报送以下基本信息：①主要投资方向及根据主要投资方向注明的基金类别。(B选项正确)②基金合同、公司章程或者合伙协议。资金募集过程中向投资者提供基金招募说明书的，应当报送基金招募说明书。(D选项正确)以公司、合伙等企业形式设立的私募基金，还应当报送工商登记和营业执照正副本复印件。"
        },
        {
            "title": "按照现行法律法规的规定，可以担任公募基金管理人的机构包括（　　）。",
            "questions": "I. 基金管理公司<br>II. 证券资产管理公司<br>III. 保险资产管理公司<br>IV. 银行理财子公司",
            "question": "A. II、III\nB. I、II、III\nC. I、II、IV\nD. I、IV",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "普通非货币市场基金的净值公告不包括（　　）。",
            "question": "A. 资产累计净值\nB. 份额累计净值\nC. 份额净值\nD. 资产净值",
            "answer": "A",
            "explain": "本题考查普通非货币市场基金的基金净值公告。普通非货币基金的净值公告内容包括基金资产净值、份额净值、份额累计净值等信息，不包括资产累计净值。故本题选A选项。"
        },
        {
            "title": "基金管理公司董事会审议事项中必须经2/3以上独立董事通过的是（　　）。",
            "questions": "I. 公司重大关联交易<br>II. 公募基金重大关联交易<br>III. 公司审计事务<br>IV. 公募基金审计事务",
            "question": "A. I、II、III\nB. I、II、III、IV\nC. II、IV\nD. I、III",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "目前，国内货币市场基金的申购和赎回应遵循的原则是（　　）。",
            "question": "A. 未知价、金额申购、份额赎回原则\nB. 确定价、金额申购、份额赎回原则\nC. 确定价、份额申购、金额赎回原则\nD. 未知价、份额申购、金额赎回原则",
            "answer": "B",
            "explain": "本题考查开放式基金申购和赎回的原则。开放式基金申购和赎回的原则为：(1)股票基金、债券基金:未知价、金额申购、份额赎回原则;"
        }, {
            "title": "关于发起式基金基金合同生效及续存的条件，以下说法正确的是（　　）。",
            "question": "A. 基金合同生效3年后，若基金资产净值低于2亿元，基金合同自动终止\nB. 受到募集份额不少于2亿元、份额持有人不少于200人的限制\nC. 公司股东资金认购基金超过1000万元且持有3年，不能算作发起式基金合同生效的条件\nD. 公司高级管理人员或基金经理认购基金金额不少于100万元",
            "answer": "A",
            "explain": "本题考查发起式基金合同生效的条件。发起式基金的基金合同生效不受基金募集金额不少于2亿元人民币，基金份额持有人的人数不少于200人的限制（B项说法错误)。"
        },
        {
            "title": "关于基金的宣传推介，（　　）形式是正确的。",
            "question": "A. 注重对行业公信力及公司品牌、形象的宣传\nB. 某基金宣传会上，PPT展示'牛市轻松赚'\nC. 某基金宣传材料上，与其他基金公司的同类型产品进行对比，突出发行主体资本雄厚而其他中小机构抗风险能力低\nD. 某基金公司在知名搜索网站上通过链接形式以醒目字体标明最后抢购",
            "answer": "A",
            "explain": "本题考查宣传推介材料的禁止性规范。A选项正确，基金管理公司和代销机构应当在宣传推介材料中加强对投资人的教育和引导，注重对行业公信力及公司品牌、形象的宣传，属于允许的行为。"
        },
        {
            "title": "公募基金管理公司A与员工张某发生劳动纠纷并败诉，法院办案人员出具《协助执行通知书》，要求A公司扣划基金财产向张某支付工资，关于本次纠纷，以下表述正确的是（　　）。",
            "question": "A. 法院的协助执行要求不符合法律的规定\nB. 张某有权取得劳动报酬，可以在离职前从基金财产中提取应得薪酬\nC. A公司有权自主选择某一基金出资向张某支付款项\nD. A公司应当依法配合法院的协助执行要求",
            "answer": "A",
            "explain": "本题考查基金独立性的相关内容。A项说法正确，D项说法错误，法院的判决内容不符合基金财产独立性的要求，不符合法律规定，A公司不可执行。B、C项说法错误，这两项的说法违背了基金财产独立性的要求，基金财产是独立于基金管理人、基金托管人的固有财产。基金管理人、基金托管人不得将基金财产归入其固有财产。"
        },
        {
            "title": "关于保险资产管理公司可以开展的资产管理业务，以下说法错误的是（　　）。",
            "question": "A. 保险资产管理公司可以受托管理保险资金投资基础设施项目\nB. 符合条件的保险资产管理公司可以出资设立公募基金管理公司\nC. 保险资产管理公司发行的资产管理产品只能面向保险公司销售",
            "answer": "C",
            "explain": "本题考查保险公司、保险资产管理公司业务。A选项说法正确，保险资产管理公司可以受托管理保险资金投资基础设施项目。B选项说法正确，符合条件的保险资产管理公司可以出资设立公募基金管理公司。"
        },
        {
            "title": "关于资产配置教育，以下说法错误的是（　　）。",
            "question": "A. 资产配置教育可以超越具体的投资行为，根本上解决投资者的困惑\nB. 资产配置教育是指导投资者对个人资产进行科学的计划和控制\nC. 投资者的个人资产配置规划会对其投资决策产生重大影响\nD. 资产配置教育是为了引导银行储蓄客户逐渐分流到证券市场",
            "answer": "D",
            "explain": "本题考查资产配置教育。A选项说法正确，许多投资者教育专家都认为投资者教育的范围应超越投资者具体的投资行为，深入整个个人资产配置中，只有这样才能从根本上解决投资者的困惑。"
        },
        {
            "title": "关于私募基金的信息披露和报送，以下表述错误的是（　　）。",
            "question": "A. 私募基金管理人相关披露信息发生重大变化事项时，在其年报中予以披露即可\nB. 私募基金管理人报送相关投资情况和杠杆运作情况，需要保证内容真实、准确、完整\nC. 私募基金管理人应当根据中国证券投资基金业协会的规定，及时填报并定期更新管理人及从业人员的有关信息\nD. 私募基金管理人应当于每个会计年度结束后的四个月内，报送经审计的财务报告和年度投资运作情况",
            "answer": "A",
            "explain": "本题考查私募基金的信息披露和报送。私募基金，是指以非公开方式向投资者募集资金设立的投资基金。"
        },
        {
            "title": "基金注册登记机构的主要职责包括（　　）。",
            "questions": "I. 基金份额登记<br>II. 发放红利<br>III. 基金账户管理<br>IV. 投资交割",
            "question": "A. II、III、IV\nB. I、III、IV\nC. I、II、IV\nD. I、II、III",
            "answer": "D",
            "explain": ""
        }, {
            "title": "关于基金管理人管理层的合规责任，以下表述正确的是（　　）。",
            "questions": "I. 建立健全合规管理组织架构<br>II. 配备充足、适当的合规管理人员，并提供必要的支持和保障<br>III. 发现违法违规行为及时报告和整改<br>IV. 审批合规管理的基本制度",
            "question": "A. I、II、IV\nB. I、II\nC. I、III、IV\nD. I、II、III",
            "answer": "D",
            "explain": "本题考查管理层的合规责任。基金管理人的管理层负责落实合规管理目标，对合规运营承担责任，履行合规管理职责：（1）建立健全合规管理组织架构（I项），遵守合规管理程序，配备充足、适当的合规管理人员，并提供必要、充分的人力、物力、财力、技术"
        },
        {
            "title": "关于ETF的信息披露要求，在基金合同和招募说明书中，需明确的内容包括（　　）。",
            "questions": "I. 基金份额的各种认购方式<br>II. 基金份额的各种申购、赎回方式<br>III. 投资者认购基金份额涉及的对价种类<br>IV. 投资者申购、赎回基金份额涉及的对价种类",
            "question": "A. II、IV\nB. I、II、III、IV\nC. I、III\nD. I、II、III",
            "answer": "B",
            "explain": "本题考查ETF基金的信息披露内容。针对ETF特有的证券申购和赎回机制，以及一级市场与二级市场并存的交易制度安排，交易所的业务规则规定了ETF特殊的信息披露事项："
        },
        {
            "title": "某基金管理人委托基金销售机构募集私募基金的，以下表述错误的是（　　）。",
            "question": "A. 销售协议与基金合同中内容不一致的，以销售协议为准\nB. 私募基金管理人与基金销售机构应以书面形式签订基金销告协议\nC. 销售协议应明确基金管理人和销告机构的权利义务划分\nD. 销售协议中涉及投资者利益的部分应作为基金合同的附件",
            "answer": "A",
            "explain": "私募基金是指以非公开方式向投资者募集资金设立的投资基金。A选项表述错误，若基金销告协议与基金合同内容不一致的，应以基金合同附件为准。B选项表述正确，私募基金管理人委托基金销售机构募集私募基金的，应当以书面形式签订基金销售协议。"
        },
        {
            "title": "根据《私募投资基金监督管理办法》的规定，符合私募基金募集方式的是（　　）。",
            "question": "A. 在私募基金募集机构某网点外的LED屏幕滚动播放私募基金信息\nB. 私募基金募集机构组织产品推介会，参会人均经过身份确认\nC. 私募基金募集机构在柜台提供私募基金产品介绍折页，供客户取阅\nD. 私募基金募集机构网站公开私募基金说明书，投资人可以通过网络进行查询",
            "answer": "B",
            "explain": "本题考查私募基金募集方式。非公开募集基金不得向对非公开募集合格投资者之外的单位和个人募集资金，不得通过报刊、电台、电视台、互联网等公众传播媒体或者讲座、报告会、分析会和布告、传单、手机短信、微信、博客和电子邮箱等方式向不特定对象宣传推介。"
        },
        {
            "title": "开放式基金在合同生效后可以有一段封闭期，但是期限不应超过（　　）。",
            "question": "A. 7日\nB. 3个月\nC. 6个月\nD. 1个月",
            "answer": "B",
            "explain": "本题考查开放式基金封闭期的申购和赎回。开放式基金是指基金份额不固定，基金份额可以在基金合同约定的时间和场所进行申购或者赎回的一种基金运作方式。开放式基金合同生效后，可以在基金合同和招募说明书规定的期限(封闭期)内不办理赎回，但该期限最长不超过3个月。"
        },
        {
            "title": "基金管理人内部控制中风险管理的基本框架包括（　　）。",
            "questions": "I. 目标设定<br>II. 风险评估<br>III. 风险应对<br>IV. 信息与沟通",
            "question": "A. I、II、III\nB. I、II、III、IV\nC. I、II、IV\nD. II、III、IV",
            "answer": "B",
            "explain": ""
        }, {
            "title": "某基金管理公司在新股申购过程中因未遵守市值申购的原则导致申购失败，事后进行原因分析时发现公司新股申购时在法规发生变化后未及时更新。该事件反映该公司在内部控制方面违背了（　　）原则。",
            "question": "A. 有效性\nB. 健全性\nC. 独立性\nD. 相互制约",
            "answer": "A",
            "explain": "本题考查内部控制的原则。A选项符合题意，内部控制的有效性是指内部控制必须讲求效率和效果，所有的控制制度必须得到贯彻执行。本题中由于法规变化后未及时更新，导致最终申购失败，没有讲求效率和效果，违背了内部控制的有效性原则。"
        },
        {
            "title": "封闭式基金上市交易的条件包括（　　）。",
            "questions": "I. 基金合同期限5年以上<br>II. 基金募集金额不低于2亿元人民币<br>III. 基金份额持有不少于1000人<br>IV. 公司自有资金认购不少于1000万元人民币",
            "question": "A. I、III、IV\nB. I、II、III、IV\nC. I、II、III\nD. II、IV",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "对基金管理人的投资运作负有监督职责的机构有（　　）。",
            "question": "A. 基金销售机构\nB. 基金托管人\nC. 基金注册登记机构\nD. 中国反洗钱监测分析中心",
            "answer": "B",
            "explain": "本题考查对非公开募集基金运作的监管。基金托管制度是规范基金运作，保护基金投资者合法权益的一项重要制度，基金托管人(B选项符合题意)作为共同受托人对基金管理人的投资运作负有监督职责。"
        },
        {
            "title": "私募基金管理人及相关服务机构保存私募基金的资料，自基金清算终止之日起不得少于（　　）年。",
            "question": "A. 15\nB. 10\nC. 5\nD. 20",
            "answer": "B",
            "explain": "本题考查非公开募集基金的信息披露和报送。私募基金管理人、托管人及销售机构应当妥善保存私募基金投资决策、交易和投资者适当性管理等方面的记录及其他相关资料，保存期限自基金清算终止之日起不得少于10年。"
        },
        {
            "title": "关于中国证券投资基金业协会的性质和组成，以下表述错误的是（　　）。",
            "question": "A. 会员包括普通会员、联席会员、观察会员、特别会员\nB. 协会章程需报中国证监会备案\nC. 权力机构为理事会\nD. 证券投资基金行业是自律性组织",
            "answer": "C",
            "explain": "本题考查基金业协会的性质和组成。C选项表述错误，基金业协会的权力机构为全体会员组成的会员大会，协议章程由会员大会制定，并报中国证监会备案。"
        },
        {
            "title": "基金管理人向投资人提供服务的渠道不包括（　　）。",
            "question": "A. 股票投资咨询专线\nB. 电子邮箱和手机短信\nC. 电话服务中心\nD. 互联网",
            "answer": "A",
            "explain": "基金客户服务提供方式包括：（1）电话服务中心(C选项)；（2）邮寄服务；（3）自动传真、电子信箱与手机短信(B选项)。"
        }, {
            "title": "对于普通的股票型开放式基金，基金管理人应当在投资者有效赎回申请日起（　　）支付赎回款。",
            "question": "A. 5个工作日内\nB. 3个工作日内\nC. 10个工作日内\nD. 7个工作日内",
            "answer": "D",
            "explain": "本题考查一般开放式基金的申购赎回。对于一般基金而言，基金管理人应当自受理基金投资者有效赎回申请之日起7个工作日内支付赎回款项。"
        },
        {
            "title": "私募基金管理人办理基金备案手续时，需要报送的材料不包括（　　）。",
            "question": "A. 基金主要投资方向和类别\nB. 公司章程或者合伙协议\nC. 基金合同、招募说明书\nD. 基金代销协议",
            "answer": "D",
            "explain": "本题考查私募基金的备案。私募基金募集完毕，基金管理人应当根据基金业协会的规定，办理基金备案手续，报送以下基本信息：（1）主要投资方向及根据主要投资方向注明的基金类别（A选项需要报送）；（2）基金合同（C选项需要报送）、公司章程或者合伙协议（B选项需要报送）。资金募集过程中向投资者提供基金招募说明书（C选项需要报送）的，应当报送基金招募说明书。以公司、合伙等企业形式设立的私募基金，还应当报送工商登记和营业执照正副本复印件。"
        },
        {
            "title": "基金连续2个开放日发生巨额赎回，以下说法错误的是（　　）。",
            "question": "A. 管理人认为有能力兑付的，可以接受全额赎回申请\nB. 管理人认为有必要的，可以暂停接受赎回申请\nC. 管理人认为全额兑付有困难的，可以对部分赎回申请延期办理\nD. 已经接受的赎回申请应当在正常支付时间内兑付",
            "answer": "D",
            "explain": "本题考查巨额赎回的处理。A选项说法正确，当基金管理人认为有能力兑付投资者的全额赎回申请时，按正常赎回程序执行。基金连续2个开放日以上发生巨额赎回，基金管理人可暂停接受赎回申请(如果只是某一日发生巨额赎回，将不能暂停)(B选项正确)；已经接受的赎回申请可以延缓支付赎回款项，但不得超过正常支付时间20个工作日，并应当在至少一种中国证监会指定的信息披露媒体上公告。"
        },
        {
            "title": "关于股票基金、债券基金的申购、赎回原则，以及货币市场基金的申购、赎回原则，以下表述正确的是（　　）。",
            "question": "A. 股票基金、债券基金的申购、赎回，采用未知价交易原则，货币市场基金的申购、赎回采用确定价原则\nB. 股票基金、债券基金的申购、赎回采用确定价原则，货币市场基金的申购、赎回采用未知价交易原则\nC. 股票基金、债券基金的申购、赎回以及货币市场基金的申购赎回，都采用确定价原则\nD. 股票基金、债券基金的申购、赎回以及货币市场基金的申购赎回，都采用未知价交易原则",
            "answer": "A",
            "explain": "本题考查开放式基金申购和赎回的原则。股票基金、债券基金的申购、赎回，采用未知价交易原则，货币市场基金的申购、赎回采用确定价原则。A选项表述正确。"
        },
        {
            "title": "基金公司股东的权利包括（　　）。",
            "questions": "I. 收益分配权<br>II. 表决权<br>III. 监督权<br>IV. 知情权",
            "question": "A. I、II、IV\nB. I、II、III\nC. I、III、IV\nD. I、II、III、IV",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "A基金管理公司的控股股东为B公司，以下安排符合基金公司治理要求的是（　　）。",
            "question": "A. A公司研究员利用业余时间为B公司证券投资活动提供建议\nB. A公司根据B公司的要求更换合规负责人\nC. A公司交易员定期向B公司提供基金重仓股明细，供B公司内部培训使用\nD. B公司根据A公司章程委派董事",
            "answer": "D",
            "explain": "本题考查基金管理公司治理的法规要求。公司独立运作原则要求：（1）股东及其实际控制人不得越过股东会和董事会直接任免基金管理公司高管人员；不得违反公司章程干预投资、研究、交易等具体事务及公司员工选聘。（A、B、C选项不符合）"
        }, {
            "title": "关于基金中基金，以下说法错误的是（　　）。",
            "question": "A. 基金中基金的基金合同可约定，基金中基金投资于货币基金的比例不得超过基金资产的15%\nB. ETF联接基金是一种特殊的基金中基金\nC. 基金中基金的基金资产80%以上投资于其他基金份额\nD. ETF是一种特殊的基金中基金",
            "answer": "D",
            "explain": "A、C选项描述正确，基金中的基金是指80%以上投资于其他基金份额的基金，可以在合同当中约定，投资货币基金的比例不得超过基金资产的15%；B选项正确，D选项错误，ETF联接基金是一种特殊的基金中基金，ETF联接基金投资于目标ETF的资产不得低于联接基金资产净值的90%，符合基金中基金的定义。"
        },
        {
            "title": "基金管理人的内部控制是指公司为防范和化解风险，保证经营运作符合公司的发展规划，在充分考虑内外部环境的基础上，通过（　　）而形成的系统。",
            "questions": "I. 建立组织机制<br>II. 运用管理方法<br>III. 实施操作程序<br>IV. 实施控制措施",
            "question": "A. I、II、III、IV\nB. I、III\nC. I、II\nD. I、IV",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "关于基金销售机构开展基金销售业务应具备的条件，以下表述错误的是（　　）。",
            "questions": "I. 基金销售业务的技术系统必须已与基金管理人、基金托管人的相应系统联网测试<br>II. 资金管理必须符合中国证监会对基金销售结算资金管理的有关要求<br>III. 必须公告评价基金投资人风险承受能力和基金管理人风险等级的方法体系",
            "question": "A. I、II\nB. II、III\nC. I、II、III\nD. I、III",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "根据《证券投资基金法》的规定，关于中国证券投资基金业协会的职责，以下表述错误的是（　　）。",
            "question": "A. 对会员与客户之间发生的基金业务纠纷进行调解\nB. 对基金从业人员的不当执业行为进行行政处罚\nC. 监督、检查会员及其从业人员的执业行为\nD. 教育和组织会员遵守有关证券投资的法律法规",
            "answer": "B",
            "explain": "中国证券投资基金业协会的职责：（1）教育和组织会员遵守有关证券投资的法律、行政法规，维护投资人合法权益：（D项正确）。"
        },
        {
            "title": "某基金管理公司的一名基金经理，在参加一次同学聚会时，从同学处了解到某上市公司即将并购另一公司的消息，这位同学是该上市公司高管，于是该基金经理利用此消息为基金进行了投资交易。该基金经理的行为（　　）。",
            "question": "A. 违反了诚实守信中不得进行不正当竞争的基本要求，同时违反了法律\nB. 违反了诚实守信中不得进行内幕交易的基本要求，同时违反了法律\nC. 违反了诚实守信中不得操纵市场的基本要求，同时违反了法律\nD. 违反了诚实守信中不得欺诈客户的基本要求，同时违反了法律",
            "answer": "B",
            "explain": "B选项说法正确，这位基金经理从该同学处获得的消息符合内幕交易的构成三要素:该同学是高管，信息来源可靠;即将并购消息属于重要且未公开，所以该基金经理违反了诚实守信中不得进行内幕交易的基本要求，同时违反了法律。"
        },
        {
            "title": "在宣传销售基金产品时，基金从业人员应当以诚实的态度和合法的方式执业，如实告知投资人可能影响其利益的重要情况，正确向其揭示投资不能作出不当承诺或保证，关于基金销售以下表述不正确的是（　　）。",
            "question": "A. 基金从业人员对基金产品进行宣传，必须摘录基金合同和招募说明书的表述，不得进行虚假或误导性的宣传\nB. 基金从业人员不得向投资人作出投资不受损失或保证最低收益的承诺\nC. 基金从业人员分发或公布的基金宣传推介材料应为基金管理机构或基金代销机构统一制作的材料\nD. 基金从业人员在陈述所推荐基金或同一基金管理人管理的其他基金的过往业绩时，应当客观、全面、准确",
            "answer": "A",
            "explain": "A选项表述错误，基金从业人员对基金产品的陈述、介绍和宣传，应当与基金合同、招募说明书等相符，不得进行虚假或误导性陈述，或出现遗漏(但不是必须摘录基金合同和招募说明书的表述)。"
        }, {
            "title": "关于QDII基金的信息披露，以下表述错误的是（　　）。",
            "question": "A. 投资境外基金的，应当披露QDII基金与境外基金之间的费率安排\nB. 当投资顾问主要负责人变动时，需要发布临时公告\nC. 定期报告中披露计入当期损益的汇兑损益\nD. 可以同时采用中文和英文，但需要明确告知投资者以哪种文字为准",
            "answer": "D",
            "explain": "QDII基金在披露相关信息时，可同时采用中文和英文，并以中文为准，可单独或同时以人民币、美元等主要外汇币种计算，各种之间转换的，应披露汇率数据来源并保持一致性。D项说法错误。"
        },
        {
            "title": "某私募基金管理公司为了销售其基金产品，下列做法正确的是（　　）。",
            "question": "A. 对投资规模较大的投资者，部分返还基金的申购费用\nB. 在微信公众号推介基金产品\nC. 选取过去一年中该公司业绩表现突出的基金进行介绍并作为本基金未来业绩的论据\nD. 通过设置特定对象确定程序的官网进行基金销售",
            "answer": "D",
            "explain": "A选项错误，应该要公平的对待所有的投资者，而且不能未经公告自变更向基金投资人的收费项目或收费标准，或通过先收后返、财务顾问费等方式实施不当激励。"
        },
        {
            "title": "基金管理人内部控制机制包括（　　）。",
            "questions": "I. 会计师事务所对基金管理人的内控有效性进行评估<br>II. 部门各级主管的检查监督<br>III. 公司督察长及其领导的监察稽核部对各部门和各项业务的监督管理<br>IV. 董事会领导的审计委员会和督察长的检查、监督、控制和指导",
            "question": "A. I、II、III、IV\nB. II、III\nC. I、II\nD. II、IV",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "依据《证券投资基金法》的规定，中国证监会可以采取的监管措施不包括（　　）。",
            "question": "A. 查询当事人和与被调查事件有关的单位和个人的资金账户、证券账户和银行账户\nB. 对可能被转移、隐匿或者损毁的文件和资料，可以予以封存\nC. 限制当事人的人身自由，但不得超过24小时\nD. 询问当事人和与被调查事件有关的单位和个人，要求其对于被调查事件有关的事项作出说明",
            "answer": "C",
            "explain": "《证券投资基金法》赋予中国证监会以下职权：进入涉嫌违法行为发生场所调查取证；询问当事人和与被调查事件有关的单位和个人，要求其对与被调查事件有关的事项做出说明（D选项包括）。"
        },
        {
            "title": "以下不属于基金上市交易公告书应披露的事项是（　　）。",
            "question": "A. 基金前十大份额持有人\nB. 基金管理人财务状况\nC. 基金募集情况\nD. 基金投资组合报告",
            "answer": "B",
            "explain": "基金上市交易公告书的主要披露事项包括：基金概况、基金募集情况与上市交易安排、持有人户数、持有人结构及前10名持有人、主要当事人介绍、基金合同摘要、基金财务状况、基金投资组合报告、重大事件揭示等。"
        },
        {
            "title": "关于公募基金管理公司基金销售业务的控制，以下说法错误的是（　　）。",
            "questions": "I. 经托管人确认的基金宣传推介材料，不必再经基金管理人有关人员审查签字<br>II. 代理客户办理申购、赎回和转换交易申请，可以不经过客户授权<br>III. 应严格审核客户开户资料，符合反洗钱与销售适用性规定<br>IV. 应严格选择合作的基金销售机构，监督基金代销行为符合协议约定",
            "question": "A. II、III\nB. I、II\nC. I、III\nD. II、IV",
            "answer": "B",
            "explain": ""
        }, {
            "title": "申请募集公募基金时，关于拟任基金管理人、基金托管人需具备的条件，以下说法正确的包括（　　）。",
            "questions": "I. 最近半年内没有因重大违法违规行为、重大失信行为受到行政处罚或者刑事处罚<br>II. 最近一年内向中国证监会提交的注册基金申请材料不存在虚假记载、误导性陈述或者重大遗漏<br>III. 拟任基金托管人必须为具有基金托管资格的商业银行<br>IV. 有符合中国证监会规定的、与管理和托管拟募集基金相适应的基金经理等业务人员",
            "question": "A. I、II、III\nB. I、II、IV\nC. II、IV\nD. II、III、IV",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "私募投资基金的投资范围包括（　　）。",
            "questions": "I. 股票<br>II. 债券<br>III. 房地产<br>IV. 期权",
            "question": "A. III、IV\nB. I、II、III\nC. I、II\nD. I、II、III、IV",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "关于基金与银行储蓄存款的特点，以下表述正确的是（　　）。",
            "question": "A. 基金管理人需向投资者、银行需向存款人定期披露资金的投资运作情况\nB. 银行储蓄存款利率相对固定，投资者本金损失的可能性也很小\nC. 基金管理人受托管理投资者的资金，需承担投资损失的风险\nD. 银行储蓄存款表现为银行的负债，是一种债权凭证",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "关于封闭式基金的交易报价，下列说法正确的是（　　）。",
            "questions": "I. 基金的申报价格最小变动单位为0.01元人民币<br>II. 基金报价单位为每10份基金价格<br>III. 基金买卖申报数量应当为100份或其整数倍<br>IV. 基金单笔最大数量应当低于100万份",
            "question": "A. III、IV\nB. I、II、III\nC. II、IV\nD. I、II、IV",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "基金管理人在合规管理中的“规”包括（　　）。",
            "questions": "I. 法律法规<br>II. 公司章程<br>III. 职业道德<br>IV. 相关自律性组织指定的行业标准",
            "question": "A. I、II\nB. I、II、IV\nC. I、II、III、IV\nD. I、IV",
            "answer": "C",
            "explain": "本题考查合规管理的含义。基金管理人的合规管理相关规则包括：立法机关和证监会发布的基本法律规则（I正确）；基金业协会和证券业协会等自律性组织指定的行业标准。"
        },
        {
            "title": "关于开放式基金的申购和赎回费用及销售服务费，下列说法错误的是（　　）。",
            "question": "A. 销售服务费由申购人承担，不从基金资产计提\nB. 申购费用由申购人承担，不列入基金资产\nC. 基金管理人可以根据情况调整申购费率\nD. 赎回费用由基金赎回人承担，不低于赎回费总额的25%计入基金资产",
            "answer": "A",
            "explain": "本题考查开放式基金的销售服务费。A选项说法错误，基金管理人可以从开放式基金资产中计提一定比例的销售服务费，用于基金的持续销售和给基金份额持有人提供服务，费用是从基金资产中计提的。"
        }, {
            "title": "对于职业道德的概念及产生的历史，以下描述错误的是（　　）。",
            "question": "A. 职业道德体现了职业对社会所负的道德责任和义务\nB. 职业道德涵盖了从业人员与服务对象、职业与职工、职业与职业之间的关系\nC. 社会分工出现相对固定的职业共同体之前产生了职业道德\nD. 职业实践是职业道德产生的基础",
            "answer": "C",
            "explain": "职业道德是随着社会分工的发展并出现相对固定的职业共同体时产生的，人们的职业实践是职业道德产生的基础。"
        },
        {
            "title": "关于基金管理人管理的证券投资基金财产的说明，以下表述错误的是（　　）。",
            "question": "A. 基金管理人因基金财产的管理运用、处分而取得的财产，应归入基金财产\nB. 法律、行政法规禁止流通的财产，不得作为基金财产\nC. 基金管理人依法解散进行清算时，基金财产作为其清算财产\nD. 基金投资者死亡或者依法解散、被依法撤销、被宣告破产时，基金财产作为其遗产或者清算财产",
            "answer": "C",
            "explain": "本题考查基金财产的独立性。C选项表述错误，基金管理人、基金托管人因依法解散、被依法撤销或者被依法宣告破产等原因进行清算的，基金财产不属于其清算财产。故本题选C选项。"
        },
        {
            "title": "关于基金销售机构人员的基本行为规范，以下表述错误的是（　　）。",
            "question": "A. 基金销售人员向投资者推介基金时首先应进行自我介绍\nB. 基金销售人员向投资者推介基金时要征得投资者的同意\nC. 基金销售人员向投资者推介基金时应该公平对待投资者\nD. 基金销售人员向投资者推介基金时可以帮助投资者下单交易",
            "answer": "D",
            "explain": "A选项正确，基金销售人员在向投资者推介基金时应首先自我介绍并出示基金销售人员身份证明及从业资格证明。B选项正确，基金销售人员在向投资者推介基金时应征得投资者的同意，如投资者不愿或不便接受推介，基金销售人员应尊重投资者的意愿。C选项正确，基金销售人员在向投资者进行基金宣传推介和销售服务时，应公平对待投资者。D选项错误，基金销售人员不得帮助投资者下单交易。"
        },
        {
            "title": "根据《中华人民共和国信托法》，关于信托收益人，以下表述正确的是（　　）。",
            "questions": "I. 委托人可以是受益人，也可以是同一信托的唯一受益人<br>II. 委托人可以是受益人，但不得是同一信托的唯一受益人<br>III. 受益人可以放弃信托受益权<br>IV. 全体受益人放弃信托受益权的，信托终止",
            "question": "A. I、II、III\nB. I、II、III、IV\nC. I、IV\nD. I、III、IV",
            "answer": "D",
            "explain": "I项正确、II项错误，委托人可以是受益人，也可以是同一信托的唯一受益人；"
        },
        {
            "title": "ETF申购和赎回清单中现金替代的类型有（　　）。",
            "questions": "I. 禁止现金替代<br>II. 全额现金替代<br>III. 必须现金替代<br>IV. 可以现金替代",
            "question": "A. I、II、III、IV\nB. I、II、III\nC. II、III、IV\nD. I、III、IV",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "在基金管理人加强合规文化建设过程中，以下各项中重要性排序相对靠后的是（　　）。",
            "question": "A. 有效落实合规考核机制\nB. 加强管理层对合规文化建设工作的重视程度\nC. 加强合规管理部门与业务部门、监察稽核部门等各部门之间的信息交流\nD. 引导并加强其他外部合作机构的合规经营意识",
            "answer": "D",
            "explain": "基金管理人加强合规文化建设，还应在以下四个方面努力：一是基金管理人管理层对合规文化建设工作足够重视。（B选项正确）二是加强合规管理部门与业务部、监察稽核部等各部门之间的信息交流和良好的互动性，实现资源共享。（C选项正确）"
        },
        {
            "title": "某基金公司员工甲认为，新成立的公司首先应该把业务发展放在优先地位，解决生存问题，可以暂时不考虑风险管理的限制要求；员工乙认为，风险管理是公司经营管理的组成部分，要覆盖公司的所有业务和部门。关于两位员工的看法，下列判断正确的是（　　）。",
            "question": "A. 员工甲的看法正确，员工乙的看法正确\nB. 员工甲的看法正确，员工乙的看法错误\nC. 员工甲的看法错误，员工乙的看法正确\nD. 员工甲的看法错误，员工乙的看法错误",
            "answer": "C",
            "explain": "甲的说法是违反了风险管理的最高性原则；乙的说法正确，遵循了全面性原则，甲员工看法错误，乙员工看法正确。故本题选C选项。"
        },
        {
            "title": "某基金从业人员在任职期间同时担任投资公司的法定代表人，监管机构据此出具警示函，具体原因是（　　）。",
            "question": "A. 直接或者间接利用他人提供或主动获取的内幕信息、未公开信息、商业秘密和客户信息谋取利益\nB. 违规利用职权为近亲属或者其他利益关系从事营利性经营活动提供便利条件\nC. 直接或者间接向他人提供内幕信息、未公开信息、商业秘密和客户信息，明示或者暗示他人从事相关交易活动\nD. 违规从事营利性经营活动，违规兼任可能影响其独立性的职务或者从事与所在机构或者投资者合法利益相冲突的活动",
            "answer": "D",
            "explain": "基于基金从业人员不得兼任不相容职务、竞业禁止和防止利益冲突的规则，《证券投资基金法》规定，公开募集基金的基金管理人的董事、监事、高级管理人员和其他从业人员，不得担任基金托管人或者其他基金管理人的任何职务，不得从事损害基金财产和基金份额持有人利益的证券交易及其他把"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/fund/2024/5/flfg-1.js